import { z } from 'zod';

export const shipSchema = z
  .object({
    name: z.string().optional(),
    mmsi: z.number().optional().nullable(),
    imo: z
      .union([
        z.number(),
        z.string().max(0, 'must be an empty string if string'),
      ])
      .optional()
      .nullable(),
  })
  .superRefine((data, ctx) => {
    if (!data.name && !data.mmsi && !data.imo) {
      ctx.addIssue({
        code: 'custom',
        path: [],
        message: 'At least one of name, MMSI, or IMO must be provided',
      });
    }
  });

export const shipsSchema = z.array(shipSchema);

export const shiplistMutateFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  color: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, {
    message: 'Invalid hex color format',
  }),
  selectedGroups: z.array(
    z.object({
      value: z.string(),
      label: z.string(),
    })
  ),
  ships: shipsSchema,
});

export type Ship = {
  id: string;
  name?: string;
  mmsi?: number;
  imo?: number | string;
};

export type ShiplistMutateFormValues = z.infer<typeof shiplistMutateFormSchema>;
